import { Injectable, Injector } from '@angular/core';
import { BaseState } from 'src/app/common/base/base.state'; import { Action, Selector, State, StateContext } from '@ngxs/store';
import { ProcedureCreditedCreate, ProcedureCreditedDelete, ProcedureCreditedRefresh, ProcedureCreditedUpdate } from './procedure-credited.action';
import { ProcedureCreditedService } from '../../services/procedure-credited.service';
import { ProcedureCredited } from '../../models/procedure-credited.model';

export class ProcedureCreditedStateModel {
  data: ProcedureCredited[] = [];
}

@State<ProcedureCreditedStateModel>({
  name: 'ProcedureCredited',
  defaults: {
    data: [],
  },
})
@Injectable()
export class ProcedureCreditedState extends BaseState {
  constructor(
    protected override injector: Injector,
    private procedureCreditedService: ProcedureCreditedService,

  ) {
    super(injector);
  }

  @Selector()
  static read(state: ProcedureCreditedStateModel) {
    return state.data;
  }

  @Action(ProcedureCreditedRefresh)
  refresh({ patchState }: StateContext<ProcedureCreditedStateModel>) {
    this.procedureCreditedService.read().subscribe(
      data => patchState({ data: data }),
      error => console.error(error),
    );
  }

  @Action(ProcedureCreditedCreate)
  create({ getState, patchState }: StateContext<ProcedureCreditedStateModel>, { item }: ProcedureCreditedCreate) {
    patchState({
      data: [...getState().data, item],
    });
  }

  @Action(ProcedureCreditedUpdate)
  update({ getState, patchState }: StateContext<ProcedureCreditedStateModel>, { id, item }: ProcedureCreditedUpdate) {
    const index = getState().data.map(x => x.id).indexOf(id);

    if (index >= 0) {
      getState().data.splice(index, 1);
      patchState({
        data: [...getState().data, item],
      });
    }
  }

  @Action(ProcedureCreditedDelete)
  delete({ getState, patchState }: StateContext<ProcedureCreditedStateModel>, { id }: ProcedureCreditedDelete) {
    patchState({
      data: getState().data.filter(x => x.id != id),
    });
  }
}
